import { application } from "./application"

import FlashController from "./flash_controller"
import MessageSizeController from "./message_size_controller"
import OauthButtonsController from "./oauth_buttons_controller"
import PasswordVisibilityController from "./password_visibility_controller"
import AuthProvidersController from "./auth_providers_controller"
import ReadReceiptsController from "./read_receipts_controller"
import RichTextEditorController from "./rich_text_editor_controller"
import SearchController from "./search_controller"

application.register("flash", FlashController)
application.register("message-size", MessageSizeController)
application.register("oauth-buttons", OauthButtonsController)
application.register("password-visibility", PasswordVisibilityController)
application.register("auth-providers", AuthProvidersController)
application.register("read-receipts", ReadReceiptsController)
application.register("rich-text-editor", RichTextEditorController)
application.register("search", SearchController)
